module.exports = __webpack_public_path__ + "static/img/alc.0349510.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alc.jpg
// module id = 2qxZ
// module chunks = 1